import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../hooks'

export const Gaming = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.gaming"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="35. Gaming activities"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'35. Gaming activities'}
              direction={'vertical'}
              data={[
                { label: 'a. Chip walking', value: 'a' },
                { label: 'b. Minimal gaming with large transactions', value: 'b' },
                { label: 'c. Suspicious use of counter checks or markers', value: 'c' },
                { label: 'd. Unknown source of chips', value: 'd' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
